import { classifyVoiceIntent } from './voiceIntent';

const prefix = 'tts_voice_review:';
const memory = new Map();
const keyFor = note => `${prefix}${encodeURIComponent(note.user_id)}:${encodeURIComponent(note.id)}`;
const draftKey = note => `${keyFor(note)}:unconfirmed-words`;
function signature(note) {
  const pieces = [note.text, note.category, note.scheduled_at || ''];
  if (note.detected_date) pieces.push(note.detected_date);
  const value = pieces.join('\u0000');
  let hash = 2166136261;
  for (let i = 0; i < value.length; i++) hash = Math.imul(hash ^ value.charCodeAt(i), 16777619);
  return (hash >>> 0).toString(36);
}
function read(note) {
  const key = keyFor(note);
  try { return JSON.parse(localStorage.getItem(key)) || memory.get(key); } catch { return memory.get(key); }
}
function write(note, state) {
  const key = keyFor(note), value = { state, signature: signature(note) };
  memory.set(key, value);
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* Optional UI state must not break saving. */ }
}
export const flagNoteForReview = note => write(note, 'review');
export function rememberVoiceDraft(note, text) {
  memory.set(draftKey(note), text);
  try { localStorage.setItem(draftKey(note), text); } catch { /* Keep the recovery draft in memory. */ }
  flagNoteForReview(note);
}
export function voiceRecoveryDraft(note) {
  try { return localStorage.getItem(draftKey(note)) || memory.get(draftKey(note)) || ''; }
  catch { return memory.get(draftKey(note)) || ''; }
}
export function clearVoiceDraft(note) {
  memory.delete(draftKey(note));
  try { localStorage.removeItem(draftKey(note)); } catch { /* Optional draft cleanup. */ }
}
export const markNoteReviewed = note => { clearVoiceDraft(note); write(note, 'reviewed'); };
export function noteNeedsReview(note) {
  if (voiceRecoveryDraft(note)) return true;
  const remembered = read(note);
  if (remembered?.signature === signature(note)) return remembered.state === 'review';
  if (note.input_method !== 'voice') return false;
  return classifyVoiceIntent(note.text).needsReview;
}
// These are per-device review acknowledgments, not a local copy of saved notes.
// Only if the API cannot confirm verbatim text, retain the unconfirmed words
// as a recovery draft until the optional editor successfully saves them.
// Text, categories and schedules are always persisted in the shared backend.